import { Component } from '@angular/core';

@Component({
  selector: 'rappider-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent { }
